.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.pes-item-card__content-reference, .pes-item-card__content-description {
  font-size: 0.875em;
  line-height: 1.4;
}

.pes-item-card {
  border: 1px solid #CED3D6;
  min-width: 200px;
  max-width: 400px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 20px;
  max-height: 420px;
  box-sizing: border-box;
  justify-content: space-between;
  width: 290px;
  text-decoration: none;
  color: #090B0C;
}

.pes-item-card__main {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding: 24px;
  padding-bottom: 0;
}

.pes-item-card__content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 10px 0 0 0;
}

.pes-item-card__image {
  height: 164px;
  width: 164px;
}

.pes-item-card__content-title {
  font-size: 1em;
  font-weight: 700;
}

.pes-item-card__content-reference {
  color: #626469;
  margin: 0;
}

:host(:not([dir="rtl"])) .pes-item-card__content-reference {
  text-align: left;
}

:host([dir="rtl"]) .pes-item-card__content-reference {
  text-align: right;
}

.pes-item-card__link {
  width: 100%;
  padding-bottom: 24px;
}

:host(:not([dir="rtl"])) .pes-item-card__link {
  text-align: left;
}

:host([dir="rtl"]) .pes-item-card__link {
  text-align: right;
}